"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _two = _interopRequireDefault(require("@/components/upload/two"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    upload: _two.default
  },
  data: function data() {
    return {
      options: [],
      form: {
        open: 0
      },
      /*        props:{
                value:'id',
                currentLabels:'label'
              },*/
      id: this.$route.query.id
    };
  },
  mounted: function mounted() {
    this.getPermissionMenu();
  },
  methods: {
    /**
     * 获取权限目录
     */
    getPermissionMenu: function getPermissionMenu() {
      var _this = this;
      var url = 'agentapi/menu';
      this.$get(url).then(function (res) {
        _this.options = res;
      });
    },
    /**
     * 点击提交
     */
    onSubmit: function onSubmit() {
      var _this2 = this;
      if (this.form.pid.length > 0) {
        this.form.pid = this.form.pid[this.form.pid.length - 1];
      } else {
        this.form.pid = 0;
      }
      var params = JSON.parse(JSON.stringify(this.form));

      // 【操作埋点】2026-05-25 pc_permission_menu_add_1 新增后台菜单
      this.$post('/agentapi/menu/add', params, this.$buildAdminOperationReportMeta({
        operation_option: '新增菜单',
        content: "\u65B0\u589E\u83DC\u5355\u300C".concat(params.title || '', "\u300D\uFF0C\u540D\u79F0 ").concat(params.name || '', "\uFF0C\u8DEF\u5F84 ").concat(params.path || '', "\uFF0C\u7EC4\u4EF6 ").concat(params.file_path || ''),
        operation_id: 'pc_permission_menu_add_1'
      })).then(function (res) {
        _this2.$message({
          message: '添加成功',
          type: 'success'
        });
      });
    }
  }
};